import axios from 'axios'
import { config } from '../../config/config'

interface CheckDeliveryParams {
  restaurantId: string
  destinationLat: number
  destinationLong: number
  sub1: string
  sub2: string
}

interface DeliveryInfo {
  id: string
  restaurantId: string
  minOrderValue: string
  deliveryCost: string
  suburbId: string
}

interface CheckDeliveryResponse {
  code: number
  data: {
    deliveryInfo: DeliveryInfo[]
  }
  errors: any[]
}

export const checkIfStoresCanDeliver = async (
  params: CheckDeliveryParams
): Promise<CheckDeliveryResponse> => {
  const { restaurantId, destinationLat, destinationLong, sub1, sub2 } = params

  const response = await axios.get(
    `${config.api.baseUrl}/deliveryLocations/v1/checkIfStoresCanDeliver`,
    {
      params: {
        restaurantId,
        destinationLat,
        destinationLong,
        sub1,
        sub2,
      },
    }
  )

  return response.data
}
